export const BaseFillCheckUnpick = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      height="18"
      width="18"
      fill="currentColor"
      fillOpacity="0.16"
      rx="3"
      stroke="currentColor"
      strokeWidth="1.5"
      x="3"
      y="3"
      data-figma-bg-blur-radius="4"
    />
    <defs>
      <clipPath id="bgblur_0_682_1942_clip_path">
        <rect height="18" width="18" rx="3" transform="translate(1.75 1.75)" x="3" y="3" />
      </clipPath>
    </defs>
  </svg>
);
